import { Link, useLocation } from 'react-router-dom';
const LocationCard = ({ location ,activeLocationId, setActiveLocationId  }) => {
    console.log(location)

    const { pathname } = useLocation();
          
      const baseUrl = process.env.REACT_APP_API_URL ;
      const imageUrl = location.media?.[0]?.formats?.large?.url 
    ? `${baseUrl}${location.media[0].formats.large.url}` 
    : "/path/to/default-image.jpg"; // Fallback image URL

    const handleClick = () => {
      setActiveLocationId(location.id);
    };
  return (
    <div   
        className={`location-card ${
          activeLocationId === location.id
            ? 'location-card--active'
            : pathname === `/locations/${location.id}`
            ? 'location-card--active'
            : ''
        }`}
        onClick={handleClick}>
      <img 
        className="location-card__image"
        src={imageUrl} 
        alt={location.title}
      />
      <div className="location-card__content">
      <Link to={`/locations/${location.id}`} className="location-card__link">
        <h4>{location.sectionTitle}</h4>
        <h3 className="location-card__title">{location.title}</h3>
        <div className="location-card__description">
          <p>{location.description}</p>
        </div>
          →</Link>
      </div>
    </div>
  );
};

export default LocationCard;